import React from 'react';
import PropTypes from 'prop-types';
import { C } from 'shared/helpers';

import Styles from './Table.module.scss';

import EtapaTile from './Etapa/Etapa';
import Row from './Row/Row';

export default function Table({ renderables, etapas, produtos, tableKey, tableRef }) {
  const { Table, Stick, LStick, Rowee, Diff, Total } = Styles;

  let pair = -1;
  let divCount = 0;

  return (
    <div className={Table} ref={tableRef}>
      <header className={Stick}>
        <div className={LStick} style={{ minWidth: '375px' }} />
        <div style={{ minWidth: renderables.length * 50 + 'px' }}>
          Nutrientes Fornecidos Kg/Ha
        </div>
        <div style={{ minWidth: '150px' }}>Relação NPK</div>
        <div style={{ minWidth: '200px' }}>Relação NPK</div>
      </header>
      <header className={Stick}>
        <div className={LStick} style={{ minWidth: '150px', left: '0px' }}>
          Etapa Fenológica
        </div>
        <div className={LStick} style={{ minWidth: '125px', left: '150px' }}>
          Época de aplicação
        </div>
        <div className={LStick} style={{ minWidth: '100px', left: '275px' }}>
          Nutrição
        </div>
        {renderables.map((element) => (
          <div key={`${tableKey}_div${++divCount}`}>{element}</div>
        ))}
        <div>N</div>
        <div>P2O5</div>
        <div>K2O</div>
        <div style={{ minWidth: '100px' }}>Quantidade Kg/ha</div>
        <div style={{ minWidth: '100px' }}>Custo Nutricional</div>
      </header>
      <div>
        {etapas.map((etapa) => (
          <div key={`${tableKey}__div${++divCount}`} className={Rowee}>
            <EtapaTile
              title={etapa.fenologica}
              lighter={!!(++pair % 2)}
              epoca={etapa.aplicacao}
            />
            <div style={{ display: 'block' }}>
              <Row
                tableKey={tableKey}
                renderables={renderables}
                produtos={etapa.produtos
                  .filter((x) => x.fase_id === 2)
                  .map((produto) => ({
                    ...produtos.find(
                      (x) => String(x.id) === String(produto.id),
                    ),
                    ...produto,
                  }))}
                lighter={!!(pair % 2)}
              />
              <Row
                tableKey={tableKey}
                renderables={renderables}
                produtos={etapa.produtos
                  .filter((x) => x.fase_id === 3)
                  .map((produto) => ({
                    ...produtos.find(
                      (x) => String(x.id) === String(produto.id),
                    ),
                    ...produto,
                  }))}
                lighter={!!(pair % 2)}
              />
            </div>
          </div>
        ))}
        <div className={C(Rowee, Total)}>
          <EtapaTile
            style={{ backgroundColor: 'lightgrey' }}
            title={'TOTAL'}
            total
          />
          <div style={{ display: 'block' }}>
            <Row
              tableKey={tableKey}
              renderables={renderables}
              produtos={etapas.map((etapa) =>
                etapa.produtos
                  .filter((x) => x.fase_id === 2)
                  .map((produto) => ({
                    ...produtos.find(
                      (x) => String(x.id) === String(produto.id),
                    ),
                    ...produto,
                  })),
              )}
              lighter={!!(pair % 2)}
            />
            <Row
              tableKey={tableKey}
              renderables={renderables}
              produtos={etapas.map((etapa) =>
                etapa.produtos
                  .filter((x) => x.fase_id === 3)
                  .map((produto) => ({
                    ...produtos.find(
                      (x) => String(x.id) === String(produto.id),
                    ),
                    ...produto,
                  })),
              )}
              lighter={!!(pair % 2)}
            />
          </div>
        </div>
        <div className={C(Rowee, Diff)}>
          <div className={Diff}>Diferença</div>
          <Row
            tableKey={tableKey}
            renderables={renderables}
            produtos={etapas.map((etapa) =>
              etapa.produtos
                .filter((x) => x.fase_id === 3)
                .map((produto) => ({
                  ...produtos.find((x) => String(x.id) === String(produto.id)),
                  ...produto,
                })),
            )}
            difference={etapas.map((etapa) =>
              etapa.produtos
                .filter((x) => x.fase_id === 2)
                .map((produto) => ({
                  ...produtos.find((x) => String(x.id) === String(produto.id)),
                  ...produto,
                })),
            )}
            lighter={!!(pair % 2)}
          />
        </div>
      </div>
    </div>
  );
}

Table.propTypes = {
  tableKey: PropTypes.string.isRequired,
  etapas: PropTypes.array.isRequired,
  produtos: PropTypes.array.isRequired,
  renderables: PropTypes.array.isRequired,
};
